module.exports = __webpack_public_path__ + "media/images/bnr01-8fa3653f8ac0ecdfb3c1bdae359c170b.png";